import { all } from 'redux-saga/effects';
import bundleSagas from './bundles/sagas.js';
import configurationSagas from './configurations/sagas.js';
import dataLayerSagas from './data-layer/sagas.js';

const productsSagas = [
    ...bundleSagas,
    ...configurationSagas,
    ...dataLayerSagas
];
function* prescriptionGlassesSaga() {
    yield all(productsSagas);
}

export { prescriptionGlassesSaga as default, productsSagas };
//# sourceMappingURL=sagas.js.map
